import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { useWindowDimensions } from 'react-native';
import { selectModals, selectModalsOrder } from 'store/app/selectors';
import { KeyboardEvents } from 'react-native-keyboard-controller';
import { Modal } from './Modal';
import { MODALS } from './ModalsConfig';

const MODAL_KEYS = Object.entries(MODALS);

export const Modals: React.FC = () => {
  const { width: windowWidth, height: rawWindowHeight } = useWindowDimensions();
  const [keyboardHeight, setKeyboardHeight] = React.useState(0);
  const windowHeight = rawWindowHeight; // - top;
  const modals = useSelector(selectModals);
  const modalsOrder = useSelector(selectModalsOrder);

  React.useEffect(() => {
    const showSubscription = KeyboardEvents.addListener(
      'keyboardWillShow',
      (e) => {
        setKeyboardHeight(e.height);
      },
    );
    const hideSubscription = KeyboardEvents.addListener(
      'keyboardWillHide',
      () => {
        setKeyboardHeight(0);
      },
    );
    return () => {
      showSubscription.remove();
      hideSubscription.remove();
    };
  }, []);

  const modalComponents = MODAL_KEYS.reduce<
    Record<
      string,
      {
        component: React.ReactElement;
        size: 'small' | 'large' | 'fullscreen';
      } | null
    >
  >((acc, [modalKey, { component: ModalComponent }]) => {
    const typedModalKey = modalKey as keyof typeof MODALS;
    const modal = modals[typedModalKey];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    acc[modalKey] = React.useMemo(() => {
      if (!modal) {
        return null;
      }
      return {
        component: <ModalComponent route={{ params: modal.params }} isModal />,
        size: modal.size,
      };
    }, [ModalComponent, modal]);
    return acc;
  }, {});

  return !modalsOrder.length ? null : (
    <>
      {modalsOrder.map(({ key: modalKey }, index) => {
        const modal = modalComponents[modalKey];
        if (!modal) {
          return null;
        }
        const isFullscreen = modal.size === 'fullscreen';
        const isSmall = modal.size === 'small';
        return (
          <Modal
            key={modalKey}
            index={index}
            maxIndex={modalsOrder.length - 1}
            windowHeight={windowHeight}
            windowWidth={windowWidth}
            keyboardHeight={keyboardHeight}
            size={isSmall ? 'small' : isFullscreen ? 'fullscreen' : 'large'}
          >
            {modal.component}
          </Modal>
        );
      })}
    </>
  );
};
